/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_2_QInputs */

const en_mk_tut_tr_2_q = /** @type {(inputs: Mk_Tut_Tr_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent answered “I need more detail”.`)
};

const id_mk_tut_tr_2_q = /** @type {(inputs: Mk_Tut_Tr_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen menjawab "saya butuh detail lebih banyak".`)
};

/**
* | output |
* | --- |
* | "The agent answered “I need more detail”." |
*
* @param {Mk_Tut_Tr_2_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_2_q = /** @type {((inputs?: Mk_Tut_Tr_2_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_2_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_2_q(inputs)
	return en_mk_tut_tr_2_q(inputs)
});